import { css } from '@stitches/core';
import { generateClassNames } from '@supabase/auth-ui-shared';
var labelDefaultStyles = css({
    fontFamily: '$labelFontFamily',
    fontSize: '$baseLabelSize',
    marginBottom: '$labelBottomMargin',
    color: '$inputLabelText',
    display: 'block'
});
var Label = function (props) {
    var _a, _b;
    var classNames = generateClassNames('label', labelDefaultStyles(), props.appearance);
    return (<label {...props} style={(_b = (_a = props.appearance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.label} class={classNames.join(' ')}>
      {props.children}
    </label>);
};
export { Label };
